import { PolicyStatus } from "@covertree/agent-portal-graphql";

export const mapPolicyStatus = (policyStatus: PolicyStatus | string) => {
  switch (policyStatus) {
    case PolicyStatus.Activated:
      return "Activated";
    case PolicyStatus.Cancelled:
      return "Cancelled";
    case PolicyStatus.Expired:
      return "Expired";
    case PolicyStatus.InitialQuote:
      return "Draft";
    case PolicyStatus.PendingCancellation:
      return "Pending Cancellation";
    case PolicyStatus.PendingEsignRequired:
      return "Pending - Esign Required";
    case PolicyStatus.PendingCancellationEsignRequired:
      return "Pending Cancellation - Esign Required";
    case PolicyStatus.PendingCancellationInspection:
      return "Pending Cancellation - Inspection";
    case PolicyStatus.PendingCancellationNonPay:
      return "Pending Cancellation - Non Pay";
    case PolicyStatus.PendingCancellationOther:
      return "Pending Cancellation - Other";
    default:
      return policyStatus;
  }
};
